import { useState } from 'react';

import { postMessageRN } from 'utils/webview.utils';

export const useModalControl = (shouldSendToRN = false) => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => {
    if (shouldSendToRN) {
      postMessageRN({ type: 'openModal' });
    }
    setIsOpen(true);
  };
  const closeModal = () => {
    if (shouldSendToRN) {
      postMessageRN({ type: 'closeModal' });
    }
    setIsOpen(false);
  };

  return { open: isOpen, onOpen: openModal, onClose: closeModal };
};
